import React, { useEffect, useState } from 'react';
import { CategoryFacet } from '@nykaa/listing-shared/type/filter';
import {
  listToTreeWithCount,
  navigateDownFilters,
  navigateUpFilters,
  updateSelectedCount,
} from 'helpers/filters/category';
import { CategoryProps } from 'types/filter';
import View from './View';


const Category = (props: CategoryProps) => {
  const { filterData, handleFilterChange, activeFilters } = props;
  const { data } = filterData;
  const [filterTree, setFilterTree] = useState([]);
  const [activeTree, setActiveTree] = useState([]);
  useEffect(() => {
    const tree = listToTreeWithCount(data, activeFilters);
    setFilterTree({ ...tree });
    const temp = tree[0];
    setActiveTree(temp);
  }, [activeFilters, data]);


  const navigateFilters = (filterValue: CategoryFacet, navigateUp: boolean) => {
    if (navigateUp) {
      const newTree = navigateUpFilters(filterValue, filterTree, activeTree);
      setActiveTree(newTree);
    } else {
      const newTree = navigateDownFilters(filterValue, filterTree, activeTree);
      setActiveTree([...newTree]);
    }
  };

  const onFilterChange = (filter: CategoryFacet, isSelected: boolean) => {
    const parentId = filter.parent_id;
    const parentDepth = parseInt(filter.depth, 10) - 1;
    updateSelectedCount(parentId, parentDepth, isSelected, filterTree);
    handleFilterChange(filter);
  };
  return (
    <View
      list={activeTree}
      selectedFilterData={activeFilters}
      navigateFilters={navigateFilters}
      handleFilterChange={onFilterChange}
    />
  );
};

export default Category;
